import _pt from "prop-types";
import React from 'react';
import * as Styled from './LegFinishPicker.styles';
import AvailableIcon from '../AvailableIcon/AvailableIcon';
import { getLegFinishImage, getSimilarVariants, sortByFeetColourAsc } from '../../helpers';
import { UPDATE_PRODUCT } from '../../types';

var LegFinishPicker = function LegFinishPicker(props) {
  var selectedProduct = props.selectedProduct,
      productVariants = props.productVariants,
      currentVariant = props.currentVariant,
      dispatch = props.dispatch;
  if (!productVariants.length) return null; // Get and sort all the variants with the same attributes except feet colour

  var similiarVariantPartNumbers = getSimilarVariants(productVariants, 'Feet colour', currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.partNumber);
  var similiarVariants = productVariants.filter(function (variant) {
    return similiarVariantPartNumbers.includes(variant.partNumber);
  });
  var sortedVariants = sortByFeetColourAsc(similiarVariants);
  return /*#__PURE__*/React.createElement(Styled.LegFinishPickerContainer, null, sortedVariants.map(function (variant) {
    var _variant$attributes$f;

    var isSelected = (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.partNumber) === variant.partNumber;
    var feetColour = (_variant$attributes$f = variant.attributes.find(function (attr) {
      return attr.type === 'Feet colour';
    })) === null || _variant$attributes$f === void 0 ? void 0 : _variant$attributes$f.value;

    var _getLegFinishImage = getLegFinishImage(feetColour, variant.partNumber),
        src = _getLegFinishImage.src,
        alt = _getLegFinishImage.alt,
        width = _getLegFinishImage.width;

    return /*#__PURE__*/React.createElement(Styled.TileContainer, {
      key: variant === null || variant === void 0 ? void 0 : variant.partNumber
    }, /*#__PURE__*/React.createElement(Styled.TileItem, {
      key: variant.partNumber,
      onClick: function onClick() {
        dispatch({
          type: UPDATE_PRODUCT,
          payload: variant
        });
      },
      "data-test": "leg-finish-tile"
    }, /*#__PURE__*/React.createElement(Styled.Image, {
      src: src,
      width: width,
      alt: alt,
      $isSelected: isSelected,
      responsive: true
    }), isSelected && /*#__PURE__*/React.createElement(AvailableIcon, null)), /*#__PURE__*/React.createElement(Styled.TileText, {
      "data-test": "leg-finish-tile-text"
    }, feetColour));
  }));
};

LegFinishPicker.propTypes = {
  productVariants: _pt.array.isRequired
};
export default LegFinishPicker;